module.exports = __webpack_public_path__ + "images/mdj/members/message/inboxdetail/inboxdetail_btn02-798427dbbcd9d4e9e65ec7afe7db1bbc.jpg";